import axios from '../http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块,post数据需要qs格式化
import base from './base'// 导入接口域名列表
//相关接口
;

const myAllWork = {
  //列表数据
  getPage(params) {
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/apyw/apywPay/page`, params);
  },
  //列表数据
  getPageManager(params) {
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/apyw/apywPay/pageManager`, params);
  },
  //列表数据
  getMyPage(params) {
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/apyw/apywPay/pageMy`, params);
  },
  //根据id查询单个信息
  getById(params) {
    return axios.get(`${base.bs}/admin/apyw/apywPay/get/${params.id}`)
  },
  //保存修改
  saveOrUpdate(params) {
    return axios.post(`${base.bs}/admin/apyw/apywPay/set`, params)
  },
  //批量生成订单--根据人ids
  setOrderBatchByPids(params) {
    return axios.post(`${base.bs}/admin/apyw/apywPay/setOrderBatchByPids`, params)
  },
  //批量修改订单--根据人ids
  setOrderBatchByIds(params) {
    return axios.post(`${base.bs}/admin/apyw/apywPay/setOrderBatchByIds`, params)
  },
  //根据id删除单个
  del(params) {
    return axios.get(`${base.bs}/admin/apyw/apywPay/del/${params.id}`)
  },
  //批量删除
  batchDel(params) {
    return axios.post(`${base.bs}/admin/apyw/apywPay/batchDel`,params)
  },
  //批量提交
  batchTijiao(params) {
    return axios.post(`${base.bs}/admin/apyw/apywPay/batchTijiao`,params)
  },
  //批量退回
  batchBack(params) {
    return axios.post(`${base.bs}/admin/apyw/apywPay/batchBack`, params)
  },
  //批量通过
  batchTg(params) {
    return axios.post(`${base.bs}/admin/apyw/apywPay/batchTg`,params)
  },
  //设置发票
  batchFp(params) {
    return axios.post(`${base.bs}/admin/apyw/apywPay/batchFp`,params)
  },
}
// 导出接口
export default myAllWork;



// WEBPACK FOOTER //
// ./src/request/api/apywPay.js